module.exports = __webpack_public_path__ + "img/logo.3024cf77.png";